import "./ShadowControls.css";

export const ShadowControls = ({ children }) => {
  return <div className="controls">{children}</div>;
};
